import React, { useEffect, useState } from 'react'
import RichText from 'src/utils/RichText'
import SbEditable from 'storyblok-react'

const StepsBlock = blok => {
  const [activeStep, setActiveStep] = useState(blok?.blok?.Blok?.[0]?._uid || '')
  // @INFO: Initialize without window reference to fix SSR issue
  const [windowWidth, setWindowWidth] = useState(0)

  useEffect(() => {
    // @INFO: Set initial window width after component mounts (client-side only)
    setWindowWidth(window.innerWidth)
    
    const handleResize = () => setWindowWidth(window.innerWidth)
    window.addEventListener('resize', handleResize)

    return () => window.removeEventListener('resize', handleResize)
  }, [])

  return (
    <SbEditable content={{ blok }}>
      {blok.blok.Blok.length <= 3 ? (
        windowWidth > 1024 ? (
          <div className='max-w-[1440px] max-h-[558px] mx-auto pt-[120px] pb-[120px] gap-[10px] flex flex-nowrap justify-center items-start'>
            {blok?.blok?.Blok.map((step, index) => {
              return (
                <div
                  key={step._uid}
                  className={`font-display w-[300px] h-auto relative border-[24px] gap-6 border-[#02D2A0] rounded-[32px] bg-[#002432] transition-all duration-300 shadow-lg ${
                    activeStep === step._uid ? 'w-[632px] h-[318px] ' : 'h-[318px]'
                  }`}
                >
                  <div
                    className={`absolute bottom-[6px] ${
                      activeStep === step._uid ? '-right-[5.5%]' : '-right-[12.5%]'
                    } w-0 h-0 rotate-90 border-l-[80px] border-l-transparent border-t-[68px] border-t-[#002432]`}
                  ></div>

                  <div className='flex justify-around'>
                    <div
                      className={`flex flex-col ${
                        activeStep === step._uid ? 'w-[144px] h-auto flex' : 'w-[215px]'
                      }`}
                    >
                      <h2 className="text-[56px] font-bold text-white">
                        0{index + 1}
                      </h2>
                      <h3 className="text-2xl font-semibold text-white mt-2">
                        {step.Title}
                      </h3>
                    </div>
                    {activeStep === step._uid && (
                      <p
                        className={`gap-10 text-white font-normal text-base ${
                          activeStep === step._uid
                            ? 'w-[355px] h-auto flex pt-8 -ml-8'
                            : 'h-auto'
                        }`}
                      >
                        <RichText>{step?.Description}</RichText>
                      </p>
                    )}
                  </div>
                  {activeStep !== step._uid && (
                    <button
                      className="lg:pt-3 pb-4 pl-4 pt-10 text-[#02D2A0] underline"
                      onClick={() => setActiveStep(step._uid)}
                    >
                      {step.ButtonTitle}
                    </button>
                  )}
                  {activeStep == step._uid && (
                    <button
                      className="lg:pt-1 pb-2 pl-4 pt-4 text-[#02D2A0] underline"
                      onClick={() => setActiveStep(step._uid)}
                    >
                      {/* {step.ButtonTitle} */}
                    </button>
                  )}

                </div>
              )
            })}
          </div>
        ) : (
          <div className='max-w-[1023px] max-md:!max-w-[325px] max-md:flex max-md:flex-col h-auto mx-auto pt-[120px] pb-[120px] gap-5 space-y-3 items-start px-3'>
            {blok?.blok?.Blok.map((step, index) => {
              return (
                <div
                  key={step._uid}
                  className={`max-w-[973px] h-auto relative mx-6 max-md:mx-0 border-[24px] gap-6 border-[#02D2A0] rounded-[32px] bg-[#002432] transition-all duration-300 shadow-lg ${
                    activeStep === step._uid ? '     ' : 'h-auto'
                  }`}
                >
                  <div
                    className={`absolute bottom-[6px] max-[941px]:-right-[4.5%] max-md:-right-[14.5%] ${
                      activeStep === step._uid ? '-right-[3.5%]' : '-right-[3.5%]'
                    } w-0 h-0 rotate-90 border-l-[80px] border-l-transparent border-t-[68px] border-t-[#002432]`}
                  ></div>

                  <div
                    className={`max-md:flex max-md:flex-col ${
                      activeStep === step._uid ? 'flex justify-between' : ' '
                    }`}
                  >
                    <div
                      className={`flex max-md:flex max-md:flex-col max-md:h-auto max-md:items-start ${
                        activeStep === step._uid
                          ? ' h-auto flex flex-col'
                          : ' justify-between items-center min-h-[171px]'
                      }`}
                    >
                      <h2 className="max-md:!pl-3 text-[56px] pl-6 font-display font-bold text-white">
                        0{index + 1}
                      </h2>
                      <div>
                        <h3
                          className={`text-2xl font-display font-semibold text-white
                          max-md:flex max-md:flex-col
                          max-md:!max-w-[217px]
                          max-md:!pl-3
                            ${
                              activeStep === step._uid
                                ? 'pl-6 h-auto flex flex-col max-w-[217px] pb-5'
                                : ' mt-2 w-[652px] ml-1 max-[941px]:!max-w-[500px]'
                            } `}
                        >
                          {step.Title}
                        </h3>
                        {activeStep !== step._uid && (
                          <button
                            className="text-[#02D2A0] underline pt-3 pb-3 max-md:!pl-3"
                            onClick={() => setActiveStep(step._uid)}
                          >
                            {step.ButtonTitle}
                          </button>
                        )}
                      </div>
                    </div>
                    {activeStep === step._uid && (
                      <p
                        className={`max-md:!p-3 max-md:!max-w-[245px] max-md:flex max-md:flex-col gap-10 text-white font-normal text-base ${
                          activeStep === step._uid
                            ? 'w-[652px] h-auto flex pt-8'
                            : 'h-auto'
                        } `}
                      >
                        <RichText>{step?.Description}</RichText>
                      </p>
                    )}
                  </div>
                </div>
              )
            })}
          </div>
        )
      ) : (
        <div className='max-w-[1023px] max-md:!max-w-[325px] max-md:flex max-md:flex-col h-auto mx-auto pt-[120px] pb-[120px] gap-5 space-y-3 items-start px-3'>
          {blok?.blok?.Blok.map((step, index) => {
            return (
              <div
                key={step._uid}
                className={`max-w-[973px] h-auto relative mx-6 max-md:mx-0 border-[24px] gap-6 border-[#02D2A0] rounded-[32px] bg-[#002432] transition-all duration-300 shadow-lg ${
                  activeStep === step._uid ? '     ' : 'h-auto'
                }`}
              >
                <div
                  className={`absolute bottom-[6px] max-[941px]:-right-[4.5%] max-md:-right-[14.5%] ${
                    activeStep === step._uid ? '-right-[3.5%]' : '-right-[3.5%]'
                  } w-0 h-0 rotate-90 border-l-[80px] border-l-transparent border-t-[68px] border-t-[#002432]`}
                ></div>

                <div
                  className={`max-md:flex max-md:flex-col ${
                    activeStep === step._uid ? 'flex justify-between' : ' '
                  }`}
                >
                  <div
                    className={`flex max-md:flex max-md:flex-col max-md:h-auto max-md:items-start ${
                      activeStep === step._uid
                        ? ' h-auto flex flex-col'
                        : ' justify-between items-center min-h-[171px]'
                    }`}
                  >
                    <h2 className="max-md:!pl-3 text-[56px] pl-6 font-display font-bold text-white">
                      0{index + 1}
                    </h2>
                    <div>
                      <h3
                        className={`text-2xl font-display font-semibold text-white
                        max-md:flex max-md:flex-col
                        max-md:!max-w-[217px]
                        max-md:!pl-3
                          ${
                            activeStep === step._uid
                              ? 'pl-6 h-auto flex flex-col max-w-[217px] pb-5'
                              : ' mt-2 w-[652px] ml-1 max-[941px]:!max-w-[500px]'
                          } `}
                      >
                        {step.Title}
                      </h3>
                      {activeStep !== step._uid && (
                        <button
                          className="text-[#02D2A0] underline pt-3 pb-3 max-md:!pl-3"
                          onClick={() => setActiveStep(step._uid)}
                        >
                          {step.ButtonTitle}
                        </button>
                      )}
                    </div>
                  </div>
                  {activeStep === step._uid && (
                    <p
                      className={`max-md:!p-3 max-md:!max-w-[245px] max-md:flex max-md:flex-col gap-10 text-white font-normal text-base ${
                        activeStep === step._uid
                          ? 'w-[652px] h-auto flex pt-8'
                          : 'h-auto'
                      } `}
                    >
                      <RichText>{step?.Description}</RichText>
                    </p>
                  )}
                </div>
              </div>
            )
          })}
        </div>
      )}
    </SbEditable>
  )
}

export default StepsBlock